import { useEffect, useRef, useState } from "react"

import type { MetricFilterAdapter } from "@/metrics/runtime-adapters"

import type { RunRowLike } from "@/types/RunRow"

import {
  HIGHLIGHT_EVENTS,
  highlightEventBus,
  type RowHoverPayload,
} from "../events/highlightEventBus"
import { getHighlightValueFromRow } from "../utils/getHighlightValueFromRow"

export function useHighlightValue(
  runRows: RunRowLike[],
  metricId: string,
  metricRecord?: MetricFilterAdapter,
): number | string | null {
  const simulationOutputIdRef = useRef<string | null>(null)
  const runRowsRef = useRef(runRows)
  const metricIdRef = useRef(metricId)
  const metricRecordRef = useRef(metricRecord)
  const [highlightValue, setHighlightValue] = useState<number | string | null>(
    null,
  )

  // Keep refs up to date without re-subscribing
  runRowsRef.current = runRows
  metricIdRef.current = metricId
  metricRecordRef.current = metricRecord

  useEffect(() => {
    const unsubscribe = highlightEventBus.subscribe(
      HIGHLIGHT_EVENTS.ROW_HOVER,
      (data?: RowHoverPayload) => {
        const newId = data?.simulationOutputId ?? null
        if (newId === simulationOutputIdRef.current) {
          return
        }
        simulationOutputIdRef.current = newId
        setHighlightValue(
          getHighlightValueFromRow(
            runRowsRef.current,
            newId,
            metricIdRef.current,
            metricRecordRef.current,
          ),
        )
      },
    )

    return unsubscribe
  }, [])

  return highlightValue
}
